var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.siteKey)?_c('div',{staticClass:"frc-captcha-container"},[_c('div',{staticClass:"frc-captcha",style:(_vm.styles),attrs:{"id":_vm.captchaElement,"data-sitekey":_vm.siteKey}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }